import React, { Component } from 'react';

import Editor from './Editor';

import './App.css';

class App extends Component {
  render() {
    return (
      <div className="container">
        <Editor />
      </div>
    );
  }
}

export default App;
